import { call, put, takeLatest, all, takeEvery } from 'redux-saga/effects';
import config from 'config';
import * as actionTypes from '../actionTypes/myAccount';
import { GET_USER_SUCCESS } from '../actionTypes/common';
import * as actionTypesReturnExchange from '../actionTypes/returnExchange';
import apiClient from '../helpers/apiClient';
import { datesDifference } from '../utils/helper';
// import getSetCookie from '../cookie';

let _client = null;
let xApiClient = 'desktop';
// conditional imports on compilation
('#if CLIENT_TYPE === "mobile"'); // eslint-disable-line
xApiClient = 'mobilesite';
('#endif'); // eslint-disable-line

function makeCall(pageName, size) {
  const client = { ..._client };
  client.setHeader();
  const url = `${config.apiPath.getOrdersListInv}?page=${pageName}&page-size=${size}`;
  return client.get(url);
}

function* getOrders({ pageName, size, shouldReset }) {
  const successAction = { type: actionTypes.ORDER_LIST_SUCCESS };
  const errorAction = { type: actionTypes.ORDER_LIST_FAIL };
  try {
    const data = yield call(async () => makeCall(pageName, size));
    successAction.data = data;
    if (shouldReset) successAction.shouldReset = shouldReset;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}

function* getOrderItemsReturnEligibilityArr({ orderList, redisCommonData }) {
  const successAction = { type: actionTypes.GET_ORDER_ITEMS_RETURN_ELIGIBILITY_ARR_SUCCESS };
  const successReturnResponseAction = {
    type: actionTypesReturnExchange.GET_RETURN_REASONS_ARR_SUCCESS,
  };
  // const errorAction = { type: actionTypes.GET_ORDER_ITEMS_RETURN_ELIGIBILITY_ARR_FAIL };
  const client = { ..._client };
  client.setHeader();
  // try {
  const returnDetails = [];
  const returnResponse = [];
  const returnReason = {};
  const callEligibilityApiArr = [];
  if (orderList) {
    const ELIGIBILITY_STATUS_HISTORY =
      redisCommonData?.ELIGIBILITY_STATUS_HISTORY &&
      JSON.parse(redisCommonData.ELIGIBILITY_STATUS_HISTORY);
    for (let i = 0; i < orderList?.length; i++) {
      try {
        /* CHECK CONDITION TO CALL ELIGIBILITY API : ITEM LEVEL */
        const paymentList = orderList[i]?.payments?.paymentList;
        const items = orderList[i]?.items;
        const isValid = datesDifference(orderList[i].createdAt);
        if ((xApiClient === 'mobilesite' && isValid < 30) || xApiClient === 'desktop') {
          if (paymentList && paymentList.length > 0 && items && items.length > 0) {
            for (let j = 0; j < paymentList.length; j++) {
              for (let k = 0; k < items.length; k++) {
                const statusHistory = items[k]?.statusHistory;
                for (let l = 0; l < statusHistory.length; l++) {
                  if (
                    ELIGIBILITY_STATUS_HISTORY &&
                    Object.keys(ELIGIBILITY_STATUS_HISTORY).includes(paymentList[j].method) &&
                    ELIGIBILITY_STATUS_HISTORY[paymentList[j].method].includes(
                      statusHistory[l].status.toLowerCase()
                    ) &&
                    !callEligibilityApiArr.includes(orderList[i].id)
                  ) {
                    callEligibilityApiArr.push(orderList[i].id);
                    break;
                  } else if (
                    ELIGIBILITY_STATUS_HISTORY &&
                    !Object.keys(ELIGIBILITY_STATUS_HISTORY).includes(paymentList[j].method) &&
                    ELIGIBILITY_STATUS_HISTORY?.others?.includes(
                      statusHistory[l].status.toLowerCase()
                    )
                  ) {
                    callEligibilityApiArr.push(orderList[i].id);
                    break;
                  }
                }
                if (callEligibilityApiArr.includes(orderList[i].id)) break;
              }
              if (callEligibilityApiArr.includes(orderList[i].id)) break;
            }
          }
        }
        /* END : CHECK CONDITION TO CALL ELIGIBILITY API : ITEM LEVEL */
        /* CALL ELIGIBILITY API only if callEligibilityApi variable is TRUE */
        if (callEligibilityApiArr.includes(orderList[i].id)) {
          const data = yield call(async () =>
            client.get(
              `${config.apiPath.v2Orders}/${orderList[i].id}/return/eligibility?fetchRefundExchangeDetails=true`
            )
          );
          returnDetails.push(data.result);
          if (data && data.result && data.result.items) {
            for (let m = 0; m < data.result.items.length; m++) {
              if (
                data.result.items[m].isExchangeable ||
                data.result.items[m].isRefundable ||
                data.result.items[m].returnable
              ) {
                if (orderList && orderList[i] && orderList[i].items) {
                  for (let n = 0; n < orderList[i].items.length; n++) {
                    if (
                      orderList[i].items[n].id + '' === data.result.items[m].id + '' &&
                      !returnResponse.includes(orderList[i].items[n].classification)
                    ) {
                      returnResponse.push(orderList[i].items[n].classification);
                    }
                  }
                }
              }
            }
          }
        }
      } catch (er) {
        returnDetails.push(er);
      }
    }
    for (let i = 0; i < returnResponse.length; i++) {
      try {
        const dataReturnResponse = yield call(async () =>
          client.get(`${config.apiPath.returnReasons}?classification=${returnResponse[i]}`)
        );
        returnReason[returnResponse[i]] =
          dataReturnResponse.result && dataReturnResponse.result.reasons;
      } catch (er) {
        returnReason[returnResponse[i]] = er;
      }
    }
    successAction.data = returnDetails;
    successReturnResponseAction.data = returnReason;
    yield put(successAction);
    yield put(successReturnResponseAction);
  }
  // } catch (er) {
  //     errorAction.error = er;
  //     yield put(errorAction);
  // }
}

function* updateInfo({ firstName, lastName, gender, email }) {
  const successAction = { type: actionTypes.UPDATE_USER_INFO_SUCCESS };
  const userSuccessAction = { type: GET_USER_SUCCESS };
  const errorAction = { type: actionTypes.UPDATE_USER_INFO_FAIL };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () =>
      client.post(`${config.apiPath.getUserInfo}`, { firstName, lastName, gender, email })
    );
    successAction.data = data;
    userSuccessAction.data = data;
    userSuccessAction.data.result.login = true;
    yield put(userSuccessAction);
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}

function* resetPassword({ oldPassword, newPassword, email, token }) {
  const successAction = { type: actionTypes.RESET_PASSWORD_SUCCESS };
  const errorAction = { type: actionTypes.RESET_PASSWORD_FAIL };
  const client = { ..._client };
  client.setHeader();
  let url = `${config.apiPath.changePassword}`;
  let apiData = {};
  if (token) {
    url = `${config.apiPath.resetPassword}/${token}`;
    apiData = { newPassword, confirmNewPassword: newPassword };
  } else {
    apiData = { oldPassword, newPassword, email };
  }
  try {
    const data = yield call(async () => client.post(url, apiData));
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}

function* checkVoucher({ voucherCode }) {
  const successAction = { type: actionTypes.CHECK_VOUCHER_SUCCESS };
  const errorAction = { type: actionTypes.CHECK_VOUCHER_FAIL };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () =>
      client.get(`${config.apiPath.giftVoucherBalance}${voucherCode}`)
    );
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}

function* storeCredit({ voucherCode }) {
  const successAction = { type: actionTypes.STORE_CREDIT_BAL_SUCCESS };
  const errorAction = { type: actionTypes.STORE_CREDIT_BAL_FAIL };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () => client.get(`${config.apiPath.storeCredit}${voucherCode}`));
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}
function* getStoreCreditOrders({ pageName, size }) {
  const successAction = { type: actionTypes.STORE_CREDIT_ORDERS_SUCCESS };
  const errorAction = { type: actionTypes.STORE_CREDIT_ORDERS_FAIL };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () =>
      client.get(`${config.apiPath.storeCredit}orders?page=${pageName}&pagesize${size}`)
    );
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}
function* getStoreCreditOrderHistory({ orderId }) {
  const successAction = { type: actionTypes.STORE_CREDIT_ORDER_HISTORY_SUCCESS };
  const errorAction = { type: actionTypes.STORE_CREDIT_ORDER_HISTORY_FAIL };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () =>
      client.get(`${config.apiPath.storeCredit}history?orderId=${orderId}`)
    );
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}
function* sendStoreCreditSMS({ orderId }) {
  const successAction = { type: actionTypes.STORE_CREDIT_ORDER_SMS_SUCCESS };
  const errorAction = { type: actionTypes.STORE_CREDIT_ORDER_SMS_FAIL };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () =>
      client.get(`${config.apiPath.storeCredit}sms?orderId=${orderId}`)
    );
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}
function* saveNeftValues({ values }) {
  const successAction = { type: actionTypes.EDIT_NEFT_SUCCESS };
  const errorAction = { type: actionTypes.EDIT_NEFT_FAIL };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () => client.post(`${config.apiPath.editNeft}`, values));
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}
function* getReturnConfig() {
  const successAction = { type: actionTypes.RETURN_ORDER_CONFIG_SUCCESS };
  const errorAction = { type: actionTypes.RETURN_ORDER_CONFIG_FAIL };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () => client.get(`${config.apiPath.returnConfig}`));
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}
function* getPfuPdRulesConfig() {
  const successAction = { type: actionTypes.PFU_PD_RULES_CONFIG_SUCCESS };
  const errorAction = { type: actionTypes.PFU_PD_RULES_CONFIG_FAIL };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () => client.get(`${config.apiPath.pfuPdRules}`));
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}
function* confirmCOD({ orderId }) {
  const successAction = { type: actionTypes.COD_CONFIRMATION_SUCCESS, orderId };
  const errorAction = { type: actionTypes.COD_CONFIRMATION_FAIL, orderId };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () =>
      client.put(`${config.apiPath.v2Orders}/${orderId}/confirm`)
    );
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}
function* updateAddress({ orderId, address }) {
  const successAction = { type: actionTypes.UPDATE_ADDRESS_SUCCESS };
  const errorAction = { type: actionTypes.UPDATE_ADDRESS_FAIL };
  const client = { ..._client };
  client.setHeader();
  try {
    const data = yield call(async () =>
      client.put(`${config.apiPath.updateShippingAddress}/${orderId}/shippingAddress`, address)
    );
    successAction.data = data;
    yield put(successAction);
  } catch (er) {
    errorAction.error = er;
    yield put(errorAction);
  }
}

export function* runMyAccountCalls(client) {
  _client = client ? Object.assign({}, client) : apiClient();
  yield all([
    takeLatest(actionTypes.ORDER_LIST_LOAD, getOrders),
    takeLatest(actionTypes.UPDATE_USER_INFO_LOAD, updateInfo),
    takeLatest(actionTypes.RESET_PASSWORD_LOAD, resetPassword),
    takeLatest(actionTypes.CHECK_VOUCHER_LOAD, checkVoucher),
    takeLatest(actionTypes.UPDATE_ADDRESS_LOAD, updateAddress),
    takeLatest(
      actionTypes.GET_ORDER_ITEMS_RETURN_ELIGIBILITY_ARR,
      getOrderItemsReturnEligibilityArr
    ),
    takeLatest(actionTypes.STORE_CREDIT_BAL_LOAD, storeCredit),
    takeLatest(actionTypes.STORE_CREDIT_ORDERS_LOAD, getStoreCreditOrders),
    takeLatest(actionTypes.STORE_CREDIT_ORDER_HISTORY_LOAD, getStoreCreditOrderHistory),
    takeLatest(actionTypes.STORE_CREDIT_ORDER_SMS_LOAD, sendStoreCreditSMS),
    takeLatest(actionTypes.EDIT_NEFT_LOAD, saveNeftValues),
    takeLatest(actionTypes.ORDER_LIST_LOAD_MORE, getOrders),
    takeLatest(actionTypes.RETURN_ORDER_CONFIG_LOAD, getReturnConfig),
    takeLatest(actionTypes.PFU_PD_RULES_CONFIG_LOAD, getPfuPdRulesConfig),
    takeEvery(actionTypes.COD_CONFIRMATION_LOAD, confirmCOD),
  ]);
}
